const Check = {
  init(){
    const submits = document.querySelectorAll('buy-buttons.buy-buttons [type="submit"]');
    const opens = document.querySelectorAll('[data-modal-open]');
    const root = document.querySelector(':root');

    if( submits.length ){
      submits.forEach(btn=>{
        btn.setAttribute('disabled','');
      });
      const checks = document.querySelectorAll('[name*="submit_check"]');
      checks.forEach(el=>{
        el.addEventListener('change',()=>{
          this.toggleSubmit(checks,submits);
        });
      })
    }
    if( opens.length ){
      opens.forEach(open=>{
        const modal = document.getElementById( open.dataset.modalOpen );
        const closes = modal.querySelectorAll('[data-modal-close]')
        open.addEventListener('click',()=>{
          document.body.style.overflow = 'hidden';
          modal.classList.add('is-open');
        });
        if(closes.length){
          closes.forEach(el=>{
            el.addEventListener('click',()=>{
              document.body.style.overflow = '';
              modal.classList.remove('is-open');
            });
          })
        }
      });
    }
  },
  toggleSubmit(checks,submits){
    let count = 0;
    const modal = checks[0].closest('.c-modal');
    const opens = document.querySelectorAll(`[data-modal-open="${modal.id}"]`);
    checks.forEach(el=>{
      if( el.checked ){
        count++;
      }
    });
    if(count == checks.length){
      submits.forEach(btn=>{
        btn.removeAttribute('disabled');
        opens.forEach(open=>{
          open.classList.add('is-ok');
        });
      });
    }else{
      submits.forEach(btn=>{
        btn.setAttribute('disabled','');
        opens.forEach(open=>{
          open.classList.remove('is-ok');
        });
      });
    }
  }
}
window.addEventListener('DOMContentLoaded',()=>{
  Check.init();
});